import { useState } from 'react';
import type { ApiResponse, MergedScheduledPayment } from 'vopay';
import { api } from '@/services/api.config';
import { useDataFetchIndicator } from '..';

export default function useCancelScheduledTransaction() {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [cancelling, setCancelling] = useState(false);

  // /scheduled-payment/cancel cannot reach the legacy VIOEftScheduledPayments
  // table, so legacy records go through the EFT-specific cancel endpoints,
  // which key off ScheduledTransactionID instead of ScheduledPaymentsID.
  function cancel(transaction: MergedScheduledPayment): Promise<ApiResponse> {
    if (!transaction.IsLegacy) {
      return api.postCancelScheduledPayment({ ScheduledPaymentsID: transaction.ID });
    }

    return transaction.PaymentType === 'debit'
      ? api.postCancelScheduledFund({ ScheduledTransactionID: transaction.ID })
      : api.postCancelScheduledWithdraw({ ScheduledTransactionID: transaction.ID });
  }

  async function cancelScheduledTransaction(transaction: MergedScheduledPayment): Promise<ApiResponse> {
    try {
      setCancelling(true);
      setDataFetchingInfo(true, 'processing', 'fullScreen');

      const res = await cancel(transaction);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error('Cancel scheduled transaction failed:', error);
      throw error;
    } finally {
      setCancelling(false);
      setDataFetchingInfo(false);
    }
  }

  return { cancelling, cancelScheduledTransaction };
}
